const broadcastTargets = {
    WEB: 'web',
    ANDROID: 'android',
    IOS: 'ios',
    DRIVER_ANDROID:'driver_android',
    DRIVER_IOS:'driver_ios'
};
Object.freeze(broadcastTargets);
export default broadcastTargets;